import { useTranslation } from 'react-i18next';
import type { IFieldDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { groupEdits } from './form/groupEdits';
import type { IFormHiddenCardProps } from './IFormHiddenCardProps';

/**
 * «Приховані поля» редактора форми (прототип v4 feHidden): поле, тип і «Додати до групи…» — поле стає в кінець вибраної групи; примітка —
 * приховані поля зберігають дані й лишаються в таблицях і поданнях. Картка є завжди, як у прототипі.
 */
export function FormHiddenCard({ rt, groups, editor }: IFormHiddenCardProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const hidden = editor.form.hidden.map((k) => rt.fields.find((f) => f.key === k)).filter((f): f is IFieldDefinition => !!f && !f.hidden);
  return (
    <section className="st-card st-fe">
      <span className="st-kicker">{t('modSettings.form.hidden')}</span>
      <div className="st-fe__list">
        {hidden.map((f) => {
          const label = strings.field(rt.key, f.key, f.label);
          return (
            <div key={f.key} className="st-feh">
              <span className="st-fef__label">{label}</span>
              <span className="st-fef__type">{t(`modDesign.types.${f.type}`, { defaultValue: f.type })}</span>
              <select className="st-select st-select--sm" value="" disabled={!editor.canEdit} aria-label={t('modSettings.form.addTo', { name: label })}
                onChange={(e) => { const target = e.target.value; if (target) editor.apply((form) => groupEdits.moveTo(form, f.key, target)); }}>
                <option value="">{t('modSettings.form.addToGroup')}</option>
                {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
              </select>
            </div>
          );
        })}
      </div>
      <div className="st-fe__note">{t('modSettings.form.hiddenNote')}</div>
    </section>
  );
}
